export default {"src":"/_next/static/media/pubg.bf221b2f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};